import { Box, BoxProps } from '@chakra-ui/react'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { useResponsive } from '../../hooks/useResponsive'
import FooterGeneralContact from './FooterGeneralContact'
import FooterNav from './FooterNav'
import FooterPressContact from './FooterPressContact'
import FooterSNS from './FooterSNS'
import FooterSupport from './FooterSupport'
import Image from '../common/Image'
import useLocale from '../../hooks/useLocale'

export type FooterProps = BoxProps & {}

const Footer: React.FC<FooterProps> = ({ ...others }) => {
  const isPC = useResponsive(false, true)
  const { isJa } = useLocale()

  return (
    <>
      {isPC && (
        <Box
          backgroundImage={withPrefix('/images/footer_bg.jpg')}
          backgroundSize="cover"
          h="570px"
          minW="contentMinWPC"
          p="150px 0 0 0"
          {...others}
        >
          <Box
            pos="relative"
            display="flex"
            m="0 auto"
            w="contentMinWPC"
            css={{
              a: {
                textDecoration: 'none',
              },
            }}
          >
            <Box w="260px" mr="40px">
              <Image src="/images/logo.png" w="260px" h="260px" />
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="space-between" mr="100px">
              <FooterNav />
              <FooterSNS />
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="space-between" flex="1">
              <FooterGeneralContact />
              <FooterPressContact />
            </Box>
            <Box pos="absolute" right="0" top={isJa ? '0' : 'auto'} bottom={isJa ? 'auto' : '0'}>
              <FooterSupport />
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}

export default Footer
